
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"fv11dtlb2a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"12","height":"12"}},[_c('path',{attrs:{"fill":"currentColor","d":"M0 0h12v12H0z"}})]),_c('g',{attrs:{"mask":"url(#fv11dtlb2a)","fill":"currentColor"}},[_c('path',{attrs:{"d":"M6.175 7.587l4.6-4.6.7.713-5.3 5.3-.706-.706-.353-.354.706-.706.353.353zM3.341 9.006L.516 6.181l.7-.712 2.125 2.125 4.6-4.6.7.712-5.3 5.3z"}})])])
          )
        }
      }
    